import { create } from "zustand";
import { CommonResponseModelWODataArray, conversionLeadsResponse, LeadOrder } from "../models/axiosModel";
import agent from "../services/api";

const getLeadOrdersPageCacheKey = (limit: number, offset: number) => `${limit}-${offset}`;

export type GetLeadOrdersApiResult = CommonResponseModelWODataArray<conversionLeadsResponse> & {
    fromCache?: boolean;
};

interface conversionLeadStoreInterface {
    conversionLeadData: LeadOrder[] | null,
    setConversionLeadData: (value: LeadOrder[] | null) => void,

    totalLeads: number,
    setTotalLeads: (value: number) => void,

    leadOrdersPageCache: Record<string, LeadOrder[]>,
    setLeadOrderspageCache: (value: Record<string, LeadOrder[]>) => void,

    getLeadOrdersApi: (limit: number, offset: number, flagUpdate: boolean) => Promise<GetLeadOrdersApiResult>
}

export const useConversionLeadStore = create<conversionLeadStoreInterface>((set, get) => {

    return {
        conversionLeadData: null,
        setConversionLeadData: (value: LeadOrder[] | null) => set({ conversionLeadData: value }),

        totalLeads: 0,
        setTotalLeads: (value: number) => set({ totalLeads: value }),

        leadOrdersPageCache: {},
        setLeadOrderspageCache: (value: Record<string, LeadOrder[]>) => set({ leadOrdersPageCache: value }),

        getLeadOrdersApi: async (limit: number, offset: number, flagUpdate: boolean) => {
            const conversionLeadData = get().conversionLeadData;
            const totalLeads = get().totalLeads;
            const cacheKey = getLeadOrdersPageCacheKey(limit, offset);
            const cachedPage = get().leadOrdersPageCache[cacheKey];

            if (cachedPage && !flagUpdate) {
                set({ conversionLeadData: cachedPage });
                return {
                    status: true,
                    fromCache: true,
                    data: {
                        lead_orders: cachedPage,
                        total_leads: totalLeads,
                    },
                } as GetLeadOrdersApiResult;
            }

            const res = await agent.getLeadOrders.get(String(limit), String(offset));
            if (res?.status) {
                const leadOrders = res?.data?.lead_orders ?? [];
                set({
                    conversionLeadData: leadOrders,
                    totalLeads: res?.data?.total_leads ?? 0,
                    leadOrdersPageCache: {
                        ...get().leadOrdersPageCache,
                        [cacheKey]: leadOrders,
                    },
                });
            } else {
                set({
                    conversionLeadData: conversionLeadData ?? [],
                    totalLeads: totalLeads,
                });
            }
            return { ...res, fromCache: false };
        }
    }
})